import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { MobileBannerLayout, DesktopBannerLayout } from '../../components/Banner';
import { tackShowInformBanner, VIEWED_TIMEOUT } from './tracking';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { IInformerBanner } from '../../types/informerBanner';
import { useApplicationContext } from '../../utils/applicationContext';

export const FormAnnotationContainer: React.FC = () => {
  const isDesktop = useIsDesktop();

  const { config } = useApplicationContext();
  const informerBannerConfig = config.get<IInformerBanner>('valuationInformerBannerConfig');

  if (!isDesktop && informerBannerConfig?.bannerData) {
    const { bannerData } = informerBannerConfig;

    return (
      <ActionAfterViewObserver
        callbackDelay={VIEWED_TIMEOUT}
        callback={() => tackShowInformBanner(bannerData.analyticsBannerType)}
      >
        <MobileBannerLayout {...bannerData} />
      </ActionAfterViewObserver>
    );
  }

  if (informerBannerConfig?.bannerData) {
    const { bannerData } = informerBannerConfig;

    return (
      <ActionAfterViewObserver
        callbackDelay={VIEWED_TIMEOUT}
        callback={() => tackShowInformBanner(bannerData.analyticsBannerType)}
      >
        <DesktopBannerLayout {...bannerData} />
      </ActionAfterViewObserver>
    );
  }

  return null;
};
